import Form from 'src/utils/Form'
import { Cookies } from 'quasar'

// Change secure to 'true' for deploying
const secure = process.env.SECURE_COOKIE

const state = {
    user: {first_name: '', middle_name: '', last_name: '', mobile:'', email: '', verification_statuses:[], permissions: [],
        google_form_viewed:false, set: false, open_orders: 0, awaiting_orders: 0, has_issue_orders: 0, rewards: {
            unused: [{total:0, currency: 'NZD', symbol: 'NZD'}], not_cancelled_orders_count: 0, welcome_reward: 0}
    },
};

const mutations = {
    'SET_USER'(state, user) {
        user.set = true
        state.user = user
    },
    'SET_GOOGLE_FORM_VIEWED'(state, payload) {
        state.user.google_form_viewed = payload
    },
    'REFRESH_USER'(state) {
        state.user = ({
            first_name: '',
            middle_name: '',
            last_name: '',
            mobile:'',
            email: '',
            verification_statuses:[],
            permissions: [],
            google_form_viewed:false,
            set: false,
            open_orders: 0,
            awaiting_orders: 0,
            has_issue_orders: 0,
            not_cancelled_orders_count: 0
        })
    },
    'SET_AWAITING_ORDERS'(state, payload) {
        state.user.awaiting_orders = payload
    },
    'SET_HAS_ISSUE_ORDERS'(state, payload) {
        state.user.has_issue_orders = payload
    },
    'USE_REWARDS'(state, payload) {
        let reward = state.user.rewards.unused.find(reward => reward.currency === payload.currency)
        if (reward) {
            reward.total -= payload.total
        } else {
            state.user.rewards.unused.push({'currency': payload.currency, 'symbol': payload.symbol, total: 0})
        }
        state.user.rewards.welcome_reward = 0
    },
};

const actions = {
    async user_info({commit}) {
        try {
            let user = await new Form().get('me');
            commit('SET_USER', user)
            Cookies.set('user', {
                name: (user.first_name ? user.first_name + ' ' : '') + (user.middle_name ? user.middle_name + ' ' : '') + user.last_name,
                permissions: JSON.stringify(user.permissions),
                awaiting_orders: user.awaiting_orders,
                lang: user.preferences.language
            }, {
                secure: secure,
                path: '/'
            })
            return user
        } catch (e) {
            commit('SET_USER', {first_name: '', middle_name: '', last_name: '', permissions: [], awaiting_orders: 0, lang: 'en-us'})
            return e
        }
    },

    set_user: ({commit}, user) => {
        try {
            commit('SET_USER', user)
            if(! Cookies.has('user')) {
                Cookies.set('user', {
                    name: user.first_name + ' ' + (user.middle_name ? user.middle_name + ' ' : '') + user.last_name,
                    permissions: JSON.stringify(user.permissions),
                    awaiting_orders: user.awaiting_orders,
                    lang: user.preferences.language
                }, {
                    secure: secure,
                    path: '/'
                })
            }
            return user
        } catch (e) {
            commit('SET_USER', {first_name: '', middle_name: '', last_name: '', permissions: [], awaiting_orders: 0, lang: 'en-us'})
            return e
        }
    },

    set_google_form_viewed({commit}, payload) {
        commit('SET_GOOGLE_FORM_VIEWED', payload)
    },

    set_awaiting_orders({commit}, payload) {
        commit('SET_AWAITING_ORDERS', payload)
    },

    set_has_issue_orders({commit}, payload) {
        commit('SET_HAS_ISSUE_ORDERS', payload)
    },

    use_rewards({commit}, payload) {
        commit('USE_REWARDS', payload)
    },
};

const getters = {
    currentUser: state => state.user,
    verifiedStates: state => state.user.verification_statuses ? state.user.verification_statuses.filter(item => item.status === 'verified').flatMap(item => item.type): [],
    getVerificationState: (state) => (type) => {
        let item = state.user.verification_statuses ? state.user.verification_statuses.find(item => item.type === type) : undefined
        return item !== undefined ? item.status : null
    },
    isUserVerified: (state, getters) => {
        return getters['verifiedStates'].length >= 2
    },
    awaitingOrders: (state) => state.user.awaiting_orders,
    hasIssueOrders: (state) => state.user.has_issue_orders,
    notCanceledOrdersCount: (state) => state.user.not_cancelled_orders_count,
};

export default {
    state,
    mutations,
    actions,
    getters
};
